import * as Cesium from 'cesium'
import CesiumTools from './CesiumTools'

export const PointOfInterest = {
  data() {
    return {
      movingEntity: null,
      pinnedEntity: null,
      pinIconUrl: null
    }
  },
  methods: {
    loadPinIconUrl(url = require('../../assets/images/Google_Maps_pin.svg')) {
      this.pinIconUrl = url
    },
    initPointsOfInterestPC() {
      this.pointsOfInterestPC = new Cesium.PrimitiveCollection()
      this.billboardCollection = new Cesium.BillboardCollection()
      this.labelCollection = new Cesium.LabelCollection()

      this.pointsOfInterestPC.add(this.billboardCollection)
      this.pointsOfInterestPC.add(this.labelCollection)

      return this.viewer.scene.primitives.add(this.pointsOfInterestPC)
    },

    initializeCursorEntity(
      iconUrl = require('../../assets/images/Google_Maps_pin.svg')
    ) {
      this.loadPinIconUrl(iconUrl)

      this.movingEntity = this.addPinEntity()

      this.viewer.scene.morphComplete.addEventListener(this.onMorphComplete)

      // Mouse over the globe to see the cartographic position
      let movingCursorHandler = new Cesium.ScreenSpaceEventHandler(
        this.viewer.scene.canvas
      )
      movingCursorHandler.setInputAction(
        this.updateCursorPosition,
        Cesium.ScreenSpaceEventType.MOUSE_MOVE
      )

      let leftClickHandler = new Cesium.ScreenSpaceEventHandler(
        this.viewer.scene.canvas
      )
      leftClickHandler.setInputAction(
        this.pinPosition,
        Cesium.ScreenSpaceEventType.LEFT_CLICK
      )
    },

    updateCursorPosition(movement) {
      let cartesian = this.viewer.camera.pickEllipsoid(
        movement.endPosition,
        this.viewer.scene.globe.ellipsoid
      )
      if (cartesian) {
        let cartographic = Cesium.Cartographic.fromCartesian(cartesian)
        let longitudeString = Cesium.Math.toDegrees(
          cartographic.longitude
        ).toFixed(4)
        let latitudeString = Cesium.Math.toDegrees(
          cartographic.latitude
        ).toFixed(4)

        this.movingEntity.position = cartesian
        this.movingEntity.billboard.show = true
        if (this.movingEntity.ellipse) {
          this.movingEntity.ellipse.show = true
        }
        this.movingEntity.label.show = true
        this.movingEntity.label.text =
          'Lon: ' +
          ('   ' + longitudeString).slice(-7) +
          '\u00B0' +
          '\nLat: ' +
          ('   ' + latitudeString).slice(-7) +
          '\u00B0'
      } else {
        this.movingEntity.label.show = false
        this.movingEntity.billboard.show = false
        if (this.movingEntity.ellipse) {
          this.movingEntity.ellipse.show = false
        }
      }
    },

    pinPosition(clickPos) {
      const cartesian = this.viewer.camera.pickEllipsoid(
        clickPos.position,
        this.viewer.scene.globe.ellipsoid
      )
      if (cartesian) {
        const cartographicPos = Cesium.Cartographic.fromCartesian(cartesian)
        this.$emit('locationPinned', {
          longitude: Cesium.Math.toDegrees(cartographicPos.longitude).toFixed(
            4
          ),
          latitude: Cesium.Math.toDegrees(cartographicPos.latitude).toFixed(4),
          altitude: cartographicPos.height
        })
      }
    },

    onCoordinatesChangedInForm(coordinates) {
      if (isNaN(coordinates.longitude) || isNaN(coordinates.latitude)) {
        return
      }
      const cartesianPos = Cesium.Cartesian3.fromDegrees(
        coordinates.longitude,
        coordinates.latitude,
        1e7
      )
      if (!this.pinnedEntity) {
        this.pinnedEntity = this.addPinEntity(cartesianPos)
      } else {
        this.pinnedEntity.position = cartesianPos
      }
      if (this.viewer.scene.mode === Cesium.SceneMode.SCENE3D) {
        this.viewer.camera.flyTo({
          destination: cartesianPos,
          easingFunction: Cesium.EasingFunction.QUADRATIC_IN
        })
      } else {
        this.pinnedEntity.billboard.heightReference =
          this.viewer.scene.mode === Cesium.SceneMode.SCENE3D
            ? Cesium.HeightReference.CLAMP_TO_GROUND
            : Cesium.HeightReference.NONE
      }
    },

    addPinEntity(cartesian) {
      return this.viewer.entities.add({
        position: cartesian,
        label: {
          show: true,
          showBackground: true,
          font: '14px monospace',
          horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
          verticalOrigin: Cesium.VerticalOrigin.TOP,
          pixelOffset: new Cesium.Cartesian2(15, 0)
        },
        billboard: {
          image: this.pinIconUrl,
          heightReference:
            this.viewer.scene.mode === Cesium.SceneMode.SCENE3D
              ? Cesium.HeightReference.CLAMP_TO_GROUND
              : Cesium.HeightReference.NONE,
          pixelOffset: new Cesium.Cartesian2(0, -17)
        }
      })
    },

    addFoVCircle(radius) {
      if (!this.movingEntity || isNaN(radius)) {
        return
      }
      this.movingEntity.ellipse = new Cesium.EllipseGraphics({
        semiMajorAxis: radius,
        semiMinorAxis: radius,
        show: true,
        fill: false,
        outline: true,
        outlineColor: Cesium.Color.RED,
        outlineWidth: 2
      })
    },

    updateFoVCircleRadius(radius) {
      if (!this.movingEntity || isNaN(radius)) {
        return
      }
      this.movingEntity.ellipse.semiMajorAxis = radius
      this.movingEntity.ellipse.semiMinorAxis = radius
    },

    onMorphComplete() {
      if (
        this.viewer.scene.mode === Cesium.SceneMode.SCENE3D &&
        this.pinnedEntity
      ) {
        this.pinnedEntity.billboard.heightReference =
          Cesium.HeightReference.CLAMP_TO_GROUND
      }
      this.movingEntity.billboard.heightReference =
        this.viewer.scene.mode === Cesium.SceneMode.SCENE3D
          ? Cesium.HeightReference.CLAMP_TO_GROUND
          : Cesium.HeightReference.NONE
    },

    createLabel(cartesianPos, labelId, displayedText) {
      return {
        position: cartesianPos,
        id: labelId,
        text: displayedText,
        pixelOffset: new Cesium.Cartesian2(15, 10),
        font: '10px sans-serif',
        scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.5, Infinity, 1),
        showBackground: true,
        backgroundColor: new Cesium.Color(0.15, 0.15, 0.15, 1),
        // eye-offset is used to make it appears above other primitives
        eyeOffset: new Cesium.Cartesian3(0, 0, -100),
        horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE
      }
    },

    createPinBillboard(cartesianPos) {
      if (!this.pinIconUrl) {
        this.loadPinIconUrl()
      }
      return {
        position: cartesianPos,
        image: this.pinIconUrl,
        // eye-offset is used to make it appears above other primitives
        eyeOffset: new Cesium.Cartesian3(0, 0, -10),
        pixelOffset: new Cesium.Cartesian2(0, -17)
      }
    },

    addPointsOfInterest(pointOfInterests) {
      if (!pointOfInterests || !pointOfInterests.length) {
        return
      }
      CesiumTools.removePrimitivesFromPC(this.labelCollection)
      CesiumTools.removePrimitivesFromPC(this.billboardCollection)
      pointOfInterests.forEach((point) => {
        const cartesianPosition = Cesium.Cartesian3.fromRadians(
          point.longitude,
          point.latitude
        )
        const label = this.createLabel(cartesianPosition, point.id, point.name)
        this.labelCollection.add(label)
        const pinBillboard = this.createPinBillboard(cartesianPosition)
        this.billboardCollection.add(pinBillboard)
      })
    }
  }
}
